import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconYoutubeStyle0 = cosmosIconCss;

const CosmosIconYoutube$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconYoutube extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '146cd4d0996b51d6d00ee24d1f4c7ac3da286ad1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9ef1612ee82806de8e6522ec3ef61f2fa44f900f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c5426b58c4c6080655c381242c8278a3f9338383', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.14 6.9a2.14 2.14 0 0 0-1.5-1.51A50.15 50.15 0 0 0 11 5a50.151 50.151 0 0 0-6.64.36 2.14 2.14 0 0 0-1.5 1.54 22.72 22.72 0 0 0-.35 4.1 22.63 22.63 0 0 0 .35 4.11 2.12 2.12 0 0 0 1.5 1.51c2.202.273 4.42.4 6.64.38a50.169 50.169 0 0 0 6.64-.36 2.12 2.12 0 0 0 1.5-1.51c.243-1.363.36-2.746.35-4.13a22.723 22.723 0 0 0-.35-4.1Zm-9.88 6.64v-5L13.7 11l-4.44 2.54Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconYoutubeStyle0; }
}, [1, "cosmos-icon-youtube", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-youtube"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-youtube":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconYoutube$1);
            }
            break;
    } });
}

const CosmosIconYoutube = CosmosIconYoutube$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconYoutube, defineCustomElement };
